import {BaseAutocomplete} from './baseAutocomplete';
import {formatShopLogo} from '../shopLogo';

class NavigationSearch extends BaseAutocomplete
{
    formatOption(item) {
        return {
            'Value': item.url,
            'Label': this.formatOptionTemplate(item),
        };
    }

    /**
     * @param {string} item.url
     * @param {string} item.image
     * @param {string} item.before
     * @param {string} item.text
     * @param {string} item.domain
     * @param {Object} item
     * @returns {string}
     */
    formatOptionTemplate(item) {
        let logo = formatShopLogo({
            src: item.image,
            name: item.shop_logo_name,
            placeholder: item.shop_logo_placeholder,
            width: 100,
            height: 71,
            size: 'small',
            alt: item.text,
        });

        return `<a href="${item.url}" data-search="option-item">
            <div class="autocomplete-item">
                <div class="autocomplete-item-img">
                    ${logo}
                </div>
                <div class="autocomplete-item-description">
                    <div class="-before">${item.before}</div>
                    <div class="-name">${item.text}</div>
                    <div class="-url">${item.domain}</div>
                </div>
            </div>
        </a>`;
    }

    select(value) {
        this.searchInput.setAttribute('data-selected-value', value);
        window.location.href = value;
    }

    blurCallback() {
        return function () {
            setTimeout(() => {
                this.Input.value = '';
                this._Close();
            }, 150);
        };
    }

    submit() {
        let searchTerm = this.searchInput.value;

        if (!searchTerm || searchTerm.length < this.minimumChars) {
            return false;
        }

        let endpointUrl = new URL(this.container.getAttribute('data-endpoint'));
        endpointUrl.searchParams.set('term', searchTerm);

        window.location.href = endpointUrl.href;
    }
}

export {NavigationSearch};
